import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nl2Br',
  standalone: true,
})
export class NlToBrPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return (value ?? '').replace(/\n/g, '<br />');
  }
}
